export const helpContentAccounts = (
  <>
    <div className="help-box-header">Profiles lookup</div>
    <div className="help-box-p">
      If you want to add your account into Akasha then all you need to do is make
      sure to go to your profile settings in-game and turn on "Show character
      details", otherwise the website won't be able to see it.
    </div>
    <div className="help-box-p">
      Genshin showcases are not updated immediately which means you might have
      to wait few minutes (at most 5 minutes) before attempting to load your
      profile (as well as when updating it with new artifacts etc)
    </div>
    <div className="help-box-p">
      If the account was already looked up on the website before then you can use
      in-game nickname to find it. Otherwise you have to use account UID or
      Enka.Network's profile name.
    </div>
  </>
);
